require('./createChoreStep1.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const find = require('lodash/collection/find');

// @ commons
const { getLanguage, FormattedText, formatText } = require('core/i18n').i18n;

// @constants
const { CHORE_MAX_AMOUNT, CHORE_MIN_AMOUNT, REPETITION_MAX_LIMIT } = require('constants/index');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const { CUSTOM_TASK_ID } = require('constants/openYoungCardChores');

//@ utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');

// @ components
const InputCharsLeft = require('components/inputCharsLeft/inputCharsLeft');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { AmountInput } = require('commonsComponents/amountInput');

class CreateChoreStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleChoreTypeChange = this.handleChoreTypeChange.bind(this);
        this.handleRepetitionTypeChange = this.handleRepetitionTypeChange.bind(this);
        this.handleConceptChange = this.handleConceptChange.bind(this);
        this.onHandleDateChange = this.onHandleDateChange.bind(this);
    }

    componentWillMount(){
        // build repetition options list
        const repetitionInitialList = [{
            value: formatText('createChoreStep-noRepetitions'),
            label: formatText('createChoreStep-noRepetitions')
        }];

        const repetitionOtherOptions = new Array(REPETITION_MAX_LIMIT)
        .join().split(',')
        .map(function(item, index){
            let _index = index + 2;

            return ({
                value: _index,
                label: _index
            });
        });
        let repetitionOptionList = [...repetitionInitialList, ...repetitionOtherOptions]
        this.props.setRepetitionOptionsList(repetitionOptionList);
    }

    getChoresTypes(choreList){
        let choreTypes = choreList.map((chore) => {
            const choreName = formatText(`openYoungCardChores-task${chore.get('choreId')}`);
            return {
                value: chore.get('choreId'),
                label: choreName
            }
        }).toArray();

        /*Following logic picks up custom task element whose choreId is 11
        and put it at the position 0 while shifting other elements
        Note: we have not added logic for sorting as API return sorted list
        on the basis of chore name
        */
        const customTask = find(choreTypes, (chore) => chore.value.toString() === CUSTOM_TASK_ID);
        choreTypes = choreTypes.filter((chore) => chore.value.toString() !== CUSTOM_TASK_ID);
        customTask && choreTypes.unshift(customTask);
        return choreTypes;
    }

    getRepetitionTypes(repetitionOptionList){
        const repetitionTypes = repetitionOptionList.size && repetitionOptionList.map((repetitionType) => {
            return {
                value: repetitionType.get('value'),
                label: repetitionType.get('label')
            }
        }).toArray();
        return repetitionTypes;
    }

    handleChoreTypeChange(choreType){
        const { immOpenYoungCardCreateChore, setChoreType } = this.props;
        const choreList = immOpenYoungCardCreateChore.get('choreList')
        const selectedChoreData = choreList.filter(chore => chore.get('choreId') === choreType.value);
        setChoreType(selectedChoreData)
    }

    handleRepetitionTypeChange(selectedRepetitionType){
        this.props.setRepetitionType(selectedRepetitionType)
    }

    handleConceptChange(event){
        const concept = event.target.value
        this.props.conceptChanged(concept);
    }

    onHandleDateChange(date){
        this.props.validityDateChanged(date);
    }

    render() {
        const { immCard, handleAmountChange, immStep, immOpenYoungCardCreateChore } = this.props;
        const choreList = immOpenYoungCardCreateChore.get('choreList');
        const choresTypes = this.getChoresTypes(choreList);
        const repetitionOptionList = immStep.get('repetitionOptionList');
        const repetitionTypes = this.getRepetitionTypes(repetitionOptionList);
        const amount = immStep.get('amount');
        const selectedEndDate = immStep.get('selectedEndDate');
        const concept = immStep.get('concept');
        const selectedRepetitionType = immStep.getIn(['selectedRepetitionType','value']);

        const selectedChoreType = immStep.getIn(['choreType',0,'choreId']);
        const currency = getCurrencySymbol(immCard.get('availableBalance'));
        const amountGreaterThanMaximunLimit = immStep.get('amountIsDirty') && amount > CHORE_MAX_AMOUNT;
        const maxLimit = [
            getFormattedString({ amount: CHORE_MAX_AMOUNT, currency })
        ];
        const minLimit = [
            getFormattedString({ amount: CHORE_MIN_AMOUNT, currency })
        ];
        const instructionMessage = formatText('createChoreStep1-maxAmountLimit', [maxLimit]);
        let amountValueErrorMessage;
        const amountValueErrorMinimumLimitCondition = immStep.get('amountIsDirty') && immStep.get('amount') === 0;
        const amountValueErrorMaximunLimitCondition = immStep.get('amountIsDirty') && immStep.get('amount') > CHORE_MAX_AMOUNT;
        let choreTypeValueErrorMessage;
        const choreTypeValueErrorMessageCondition = immStep.get('choreTypeIsDirty') && immStep.get('choreType').length === 0;

        if(amountValueErrorMinimumLimitCondition){
            amountValueErrorMessage = formatText('createChoreStep1-amountMinimumLimitError', [minLimit]);
        } else if (amountValueErrorMaximunLimitCondition){
            amountValueErrorMessage = formatText('createChoreStep1-amountMaximumLimitError', [maxLimit]);
        }

        if(choreTypeValueErrorMessageCondition){
            choreTypeValueErrorMessage = formatText('createChoreStep1-emptyChoreTypeError');
        }

        return (
            <article className="create-chore-step-one">
                <header className="create-chore-step-one__header">
                    <FormattedText value="createChoreStep1-title" className="create-chore-step-one__title" />
                </header>
                <section className="create-chore-step-one__content">
                    <form>
                        <fieldset className="create-chore-step-one__chore-select">
                            <OKSelect
                                className="create-chore-step-one__chore-select-dropdown"
                                errorMessage={choreTypeValueErrorMessage}
                                errorState={choreTypeValueErrorMessageCondition}
                                label={formatText('createChoreStep-chore')}
                                name="create-chore-step-one-chore"
                                onChange={this.handleChoreTypeChange}
                                options={choresTypes}
                                searchable={false}
                                value={selectedChoreType}
                            />
                        </fieldset>
                        <fieldset className="create-chore-step-one__amount">
                            <label>
                                <AmountInput
                                    amount={amount}
                                    callback={handleAmountChange}
                                    disablePaste
                                    error={amountGreaterThanMaximunLimit || amountValueErrorMinimumLimitCondition}
                                    errorMsg={amountValueErrorMessage}
                                    hideFocusZero
                                    id="inp_CreateChoreStep1_Amount"
                                    label={formatText('createChoreStep-amount')}
                                    language={getLanguage()}
                                    min={0}
                                    showBlurZero
                                />
                            </label>
                            <span className="create-chore-step-one__currency">
                                {currency}
                            </span>
                            <p className="create-chore-step-one__max-limit">{instructionMessage}</p>
                        </fieldset>
                        <fieldset className="create-chore-step-one__datepicker">
                            <DatePickerCustom
                                callback={this.onHandleDateChange}
                                dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                                label={formatText('createChoreStep-selectedEndDate')}
                                locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                                minDate={immStep.get('minDate')}
                                placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                                selectedDate={selectedEndDate}
                            />
                        </fieldset>
                        <fieldset className="create-chore-step-one__repetitions-select">
                            <OKSelect
                                className="create-chore-step-one__repetitions-select-dropdown"
                                label={formatText('createChoreStep-repetitions')}
                                name="create-chore-step-one-repetitions"
                                onChange={this.handleRepetitionTypeChange}
                                options={repetitionTypes}
                                searchable={false}
                                value={selectedRepetitionType}
                            />
                        </fieldset>
                        <div className="create-chore-step-one__concept">
                            <InputCharsLeft
                                callback={this.props.conceptChanged}
                                initialValue={concept}
                                label={formatText('createChoreStep-concept')}
                                maxLength="80"
                            />
                        </div>

                    </form>
                </section>
            </article>
        )
    }
}

CreateChoreStep1.propTypes = {
    conceptChanged: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    immCard: PropTypes.object.isRequired,
    immOpenYoungCardCreateChore: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    setChoreType: PropTypes.func.isRequired,
    setRepetitionOptionsList: PropTypes.func.isRequired,
    setRepetitionType: PropTypes.func.isRequired,
    validityDateChanged: PropTypes.func.isRequired
};

module.exports = CreateChoreStep1;
